import ApiUserDetailsDrawer from './ApiUserDetailsDrawer.vue';

export default {
	ApiUserDetailsDrawer,
};
